function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var _Input_baseStyle;
import { jsx as _jsx } from "react/jsx-runtime";
import { numberInputAnatomy as parts } from "../chakra/internal";
import { ThemedInput as Input } from "./Input";
import { NumberIncrementStepper as ChakraNIS, NumberDecrementStepper as ChakraNDS, cssVar, calc } from "../chakra/internal";
import { ChevronBottomIcon, ChevronTopIcon } from "@tempo/icons";
const { variants, defaultProps } = Input;
const $stepperWidth = cssVar('number-input-stepper-width');
const $inputPadding = cssVar('number-input-input-padding');
const baseStyleStepper = {
    borderStart: '1px solid',
    borderStartColor: 'inherit',
    color: 'inherit',
    _active: {
        bg: 'background.neutral.tertiary.pressed'
    },
    _hover: {
        bg: 'background.neutral.tertiary.hovered',
        color: 'text.neutral.primary.hovered'
    },
    _disabled: {
        bg: 'background.neutral.tertiary.disabled',
        _hover: {
            bg: 'background.neutral.tertiary.disabled'
        },
        cursor: 'not-allowed'
    }
};
var _Input_baseStyle_field;
const baseStyle = {
    root: {},
    field: (_Input_baseStyle_field = (_Input_baseStyle = Input.baseStyle) === null || _Input_baseStyle === void 0 ? void 0 : _Input_baseStyle.field) !== null && _Input_baseStyle_field !== void 0 ? _Input_baseStyle_field : {},
    stepperGroup: {},
    stepper: baseStyleStepper
};
function getSize(size) {
    const sizeStyle = Input.sizes[size];
    const radius = {
        medium: 'md',
        small: 'sm'
    };
    // Hardcoded for now as the border used for the border is not available in sizes
    const inputBorder = '2px';
    const iconSize = {
        medium: 'icon.m',
        small: 'icon.s'
    };
    return {
        root: {
            [$stepperWidth.variable]: iconSize[size],
            [$inputPadding.variable]: calc($stepperWidth).add('0.5rem').toString()
        },
        field: _object_spread_props(_object_spread({}, sizeStyle.field), {
            verticalAlign: 'top',
            paddingEnd: iconSize[size]
        }),
        stepperGroup: {
            alignItems: 'center',
            borderStart: 'solid 1px',
            borderStartColor: 'border.neutral.primary.default',
            bottom: inputBorder,
            h: '100%',
            justifyContent: 'center',
            mx: '0',
            my: 'auto',
            py: inputBorder,
            right: inputBorder,
            top: inputBorder,
            width: [
                $stepperWidth.reference
            ],
            _rtl: {
                right: 'auto',
                left: inputBorder
            }
        },
        stepper: {
            border: 'none',
            h: '100%',
            maxH: iconSize[size],
            maxW: iconSize[size],
            w: '100%',
            '> svg': {
                boxSize: `calc(100% - ${inputBorder})`
            },
            _first: {
                borderTopEndRadius: radius[size],
                _rtl: {
                    borderTopEndRadius: 'none',
                    borderTopStartRadius: radius[size]
                }
            },
            _last: {
                borderBottomEndRadius: radius[size],
                _rtl: {
                    borderBottomEndRadius: 'none',
                    borderBottomStartRadius: radius[size]
                }
            }
        }
    };
}
const sizes = {
    medium: getSize('medium'),
    small: getSize('small')
};
export const NumberDecrementStepper = ChakraNDS;
NumberDecrementStepper.defaultProps = {
    children: /*#__PURE__*/ _jsx(ChevronBottomIcon, {
        color: "icon.neutral.primary.default"
    })
};
export const NumberIncrementStepper = ChakraNIS;
NumberIncrementStepper.defaultProps = {
    children: /*#__PURE__*/ _jsx(ChevronTopIcon, {
        color: "icon.neutral.primary.default"
    })
};
export const ThemedNumberInput = {
    parts: parts.keys,
    baseStyle,
    sizes,
    variants,
    defaultProps
};

//# sourceMappingURL=NumberInput.js.map